import styled from 'styled-components/macro';

export const Container = styled.div`
  padding: 30px 30px 0;
`;

export const Controls = styled.div``;

export const ControlsLabel = styled.div`
  margin-bottom: 14px;
  font-size: 12px;
  color: #444;
`;

export const InputWrapper = styled.div`
  margin-bottom: 10px;
`;
